import { render, staticRenderFns } from "./upload-photo.vue?vue&type=template&id=6c44e1d0&scoped=true"
import script from "./upload-photo.vue?vue&type=script&lang=js"
export * from "./upload-photo.vue?vue&type=script&lang=js"
import style0 from "./upload-photo.vue?vue&type=style&index=0&id=6c44e1d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c44e1d0",
  null
  
)

export default component.exports